import React, { useEffect, useState } from 'react'
import cn from 'classnames'

import CheckBoxUniversal from 'app/components/CheckBoxUniversal'
import AvailableDomain from 'app/components/SVGS/AvailableDomain'
import { EColors } from 'app/constants/colors'
import { CheckBoxWithBackgroundPropType } from './CheckBoxWithBackground.interface'

import './styles.scss'

export const bc = 'check-box-with-background'

const svgProps = {
  viewBox: '0 0 16 16',
  checkcolor: EColors.BLUE,
  background: EColors.WHITE,
  circleborder: '#094d76',
  width: '21px',
  height: '21px',
  style: { marginRight: '9.9px' },
}

export const disabledComponent = ({ text, disabled, left }: { text: string; disabled?: boolean; left?: boolean }) => (
  <div
    className={cn(bc, `${bc}__unchecked`, {
      [`${bc}__unchecked--disabled`]: disabled,
      [`${bc}__left`]: left,
    })}
  >
    <div className={cn(`${bc}__unchecked-circle`)}>{''}</div>
    {text}
  </div>
)

export const enabledComponent = ({ text, disabled, left }: { text: string; disabled?: boolean; left?: boolean }) => (
  <div
    className={cn(bc, `${bc}__checked`, {
      [`${bc}__checked--disabled`]: disabled,
      [`${bc}__left`]: left,
    })}
  >
    <AvailableDomain {...svgProps} />
    {text}
  </div>
)

export const CheckBoxWithBackground: React.FC<CheckBoxWithBackgroundPropType> = ({
  text,
  disabled,
  type,
  className,
  value,
  marked,
  ...props
}) => {
  return (
    <CheckBoxUniversal
      disabledComponent={disabledComponent({ text, disabled })}
      enabledComponent={enabledComponent({ text, disabled })}
      input={{
        value,
        type,
        disabled,
        marked,
        ...props,
      }}
      className={className}
    />
  )
}

export default CheckBoxWithBackground
